import { baseService } from "../base";
import { PaginationResponse } from "../type";
import { CreateExpenseDto, GetExpensesParams, UpdateExpenseDto } from "./expense.types";
import { TExpense, ExpenseStats } from "~/types/expense";

export const expenseService = {
  getExpenses: async (params?: GetExpensesParams) => {
    const { data } = await baseService.get<PaginationResponse<TExpense>>(
      "/expenses",
      {
        params,
      }
    );
    return data;
  },

  getExpenseStats: async () => {
    const { data } = await baseService.get<ExpenseStats>("/expenses/stats");
    return data;
  },

  getExpenseById: async (expenseId: string) => {
    const { data } = await baseService.get<TExpense>(`/expenses/${expenseId}`);
    return data;
  },

  createExpense: async (payload: CreateExpenseDto) => {
    const { data } = await baseService.post("/expenses", payload);
    return data;
  },

  updateExpense: async ({
    expenseId,
    payload,
  }: {
    expenseId: string;
    payload: UpdateExpenseDto;
  }) => {
    const { data } = await baseService.patch(`/expenses/${expenseId}`, payload);
    return data;
  },

  deleteExpense: async (expenseId: string) => {
    const { data } = await baseService.delete(`/expenses/${expenseId}`);
    return data;
  },

  approveExpense: async (expenseId: string) => {
    const { data } = await baseService.post(`/expenses/${expenseId}/approve`);
    return data;
  },

  rejectExpense: async (expenseId: string, notes?: string) => {
    const { data } = await baseService.post(`/expenses/${expenseId}/reject`, { notes });
    return data;
  },

  markExpenseAsPaid: async (expenseId: string) => {
    const { data } = await baseService.post(`/expenses/${expenseId}/mark-paid`);
    return data;
  },

  createExpenseInvoice: async ({
    expenseId,
    payload,
  }: {
    expenseId: string;
    payload: {
      invoiceNumber?: string;
      dueDate?: string;
      memo?: string;
    };
  }) => {
    const { data } = await baseService.post(`/expenses/${expenseId}/create-invoice`, payload);
    return data;
  },

  getExpenseInvoices: async (params?: GetExpensesParams) => {
    const { data } = await baseService.get<PaginationResponse<TExpense>>(
      "/expenses/invoices",
      {
        params,
      }
    );
    return data;
  },
}; 